import React, {Component} from 'react';
export default class FinancialPlanCapsuleWrapperView extends Component {
    componentDidMount() {
        const {
            fetchData,
            capsuleId,
            clientId,
        } = this.props;

        fetchData(capsuleId, clientId);
    }

    componentWillUnmount() {
        const {
            resetData,
            capsuleId,
            clientId,
        } = this.props;
        resetData(capsuleId, clientId);
    }

    renderChildren() {
        const {
            children,
            capsuleId,
            fpId,
            proposed_plan,
            clientId,
            isCurrent,
        } = this.props;
        return React.Children.map(
            children,
            (child) => child ? React.cloneElement(
                child,
                {
                    fpId,
                    proposed_plan,
                    capsuleId,
                    clientId,
                    isCurrent,
                }
            ) : null
        );
    }

    render() {
        const {
            hasFpId,
            hasData
        } = this.props;
        return hasData && hasFpId ? <div className="capsule-wrapper">
            {this.renderChildren()}
        </div> : null;
    }
};